export default __webpack_public_path__ + "static/media/bbnaija.c386b8e4.png";